import { createReducer } from '@reduxjs/toolkit'

import { setToken } from '@/redux/global-actions'

const initialState: {
  token?: string
} = {
  token: undefined,
}

export default createReducer(initialState, (builder) => {
  builder.addCase(setToken, (state, { payload }) => {
    state.token = payload
  })
})
